export const GOOGLE_SHEETS_CONFIG = {
  SPREADSHEET_ID: '1l20Z_CZ_6aZjTHVcyVP8axFqU3etBJbBIPq4K6ft_5I',
  SHEET_NAME: 'Eventos',
  JSON_URL: (spreadsheetId: string) => 
    `https://docs.google.com/spreadsheets/d/${spreadsheetId}/gviz/tq?tqx=out:json&gid=0`
} as const; 